import React, { useEffect } from "react";
import { useState } from "react";
import AuthUser from "./AuthUser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../front_assets/Logo_Image/greatpharmalogo.png";
import "../CSS/login.css";
import Swal from "sweetalert2";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";

export default function Login() {
  const { http, setToken } = AuthUser();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState([]);
  const [loading, setloading] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const emailRef = React.useRef(null);

  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }, [emailRef]);
  const submitForm = (e) => {
    e.preventDefault();
    setloading(true);
    http
      .post("login", { email: email, password: password })
      .then((res) => {
        console.log(res);
        if (res.data.user.user_type === "empty") {
          Swal.fire(
            "Warning",
            "Please ask admin to assign your role",
            "warning"
          );
        } else {
          setToken(res.data.user, res.data.access_token);
        }
        http.get(`clear`);
        setloading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setError(err.response.data.error);
        setloading(false);
      });
  };

  return (
    <div className="app-content">
      <div className="content-wrapper">
        <div className="content-body">
          <div className="auth-wrapper auth-basic px-2">
            <div className="auth-inner my-2">
              <ToastContainer />
              {/* Login basic */}
              <div
                className="col-md-3  mx-auto"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <div className="card mb-0">
                  <div className="card-body">
                    <div className="text-center">
                      <a href="#" className="brand-logo">
                        <img
                          style={{ width: "35%" }}
                          src={logo}
                          alt=""
                          srcset=""
                        />
                        <h1 style={{}} className="ms-1 fw-bold logoPos">
                          POS
                        </h1>
                      </a>
                      <h4 className="card-title mb-1"></h4>
                      <p className="card-text mb-3">
                        Welcome back! Please sign in to your account to
                        continue.
                      </p>
                    </div>
                    <form
                      className="auth-login-form mt-2"
                      onSubmit={submitForm}
                    >
                      <div className="mb-1">
                        <label htmlFor="login-email" className="form-label">
                          Email
                        </label>
                        <input
                          ref={emailRef}
                          type="text"
                          className="form-control"
                          name="email"
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter your email"
                        />
                      </div>
                      <div className="mb-1">
                        <div className="d-flex justify-content-between">
                          <label
                            className="form-label"
                            htmlFor="login-password"
                          >
                            Password
                          </label>
                        </div>
                        <div className="input-group input-group-merge form-password-toggle">
                          <input
                            type={isShowPassword ? "text" : "password"}
                            className="form-control form-control-merge"
                            name="password"
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <span
                            onClick={() => setIsShowPassword(!isShowPassword)}
                            className="input-group-text cursor-pointer"
                          >
                            {isShowPassword ? (
                              <HiOutlineEyeOff />
                            ) : (
                              <HiOutlineEye />
                            )}
                          </span>
                          <br />
                        </div>
                      </div>
                      <button
                        disabled={loading}
                        type="submit"
                        className="btn btn-primary w-100 mt-4"
                      >
                        Sign In
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-40"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
